<template>
  <div id="TableTion">
    <el-table
      ref="tableRef"
      :data="tableData"
      @row-dblclick="rowdblclick"
      @row-click="rowclick"
      highlight-current-row
      :summary-method="getSummaries"
      :show-summary="showsummary"
      border
      :fit="asdaaf"
      style="width: 100%"
      :height="heights"
      class="tabone_sty"
      :header-cell-style="{
        background: '#eef1f6',
        color: '#000',
        fontSize: '14px',
        height: '37px',
        padding: '0',
        fontWeight: 'bold',
      }"
    >
      <el-table-column
        width="80"
        height="500"
        align="center"
        prop="BarCode"
        fixed="left"
      >
        <template slot="header">
          <i
            :class="isInners"
            @click="clickIcon"
            style="color: #2594ff; font-size: 18px"
          ></i>
        </template>
        <template slot-scope="scope">{{ scope.$index + 1 }}</template>
      </el-table-column>
      <el-table-column width="50" align="center" label="类型" v-if="IfShows">
        <template slot-scope="scope">
          <i
            :class="scope.row.IsDir ? 'el-icon-folder' : 'el-icon-tickets'"
            style="color: #e9cb70; font-size: 18px"
          ></i>
        </template>
      </el-table-column>
      <template v-for="(obj, index) in ObtainHeader">
        <el-table-column
          :label="obj.Rename"
          align="center"
          width="180"
          v-if="obj.Key == 'Number' && obj.Show == true"
          :key="index"
        >
          <template slot-scope="scope">
            <el-button
              @click.native.prevent="invalidRow(scope.row)"
              type="text"
              size="small"
              >{{ scope.row[obj.Key] }}</el-button
            >
          </template>
        </el-table-column>
        <el-table-column
          :label="obj.Rename"
          :prop="obj.Key"
          width="200"
          align="center"
          v-else-if="obj.Key !== 'Number' && obj.Show == true"
          :key="index"
        >
          <template slot-scope="scope">
            <span class="span_inner_sty">{{ scope.row[obj.Key] }}</span>
          </template>
        </el-table-column>
      </template>

      <el-table-column
        align="center"
        fixed="left"
        label="操作"
        width="50"
        class="asdadfas"
      >
        <template slot-scope="scope">
          <el-button
            @click="handleClick(scope.row)"
            :disabled="scope.row.Status == 0 ? false : true"
            type="text"
            size="small"
            >验收</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPages"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pageSizes"
      layout="total, sizes,prev, pager, next, jumper"
      :total="totals"
    ></el-pagination>
  </div>
</template>

<script>
// import local from "@/utils/local.js";
// import session from "@/utils/session.js";
// import loginVue from "@/views/Login/login.vue";
export default {
  name: "TableTion",
  data() {
    return {
      Status:true,
      ifshows: this.ifshow,
      ifshowsss: this.ifshowss,
      isInner: this.isInners,
      asdaaf: true,
      data: this.tableData,
      icons: false,
      icon: false,
      column: this.columnS,
      columnSs: this.ColumnSs,
      currentPage: this.currentPages, //当前页码
      total: this.totals, //总页数
      pageSize: this.pageSizes, //每页显示数量
      // tableData: [],
      img: this.imgs,
      // filetext: require("../../assets/images/icon_set.png"),
      filetext: "",
      file: "",
      Discontext: true,
      Discontexts: "",
      Discon: [],
      taData: [],
      taData1: this.ObtainHeader,
      Hierarchy: this.HierarchyS,
      showsummary: this.ShowSummary,
    };
  },
  props: {
    ifshow: {
      type: Boolean,
      default: true,
    },
    ifshowss: {
      type: Boolean,
      default: false,
    },
    ShowSummary: {
      type: Boolean,
      default: false,
    },
    HierarchyS: Array,
    IfShows: {
      type: Boolean,
      default: false,
    },
    tableData: Array,
    ObtainHeader: Array,
    currentPages: Number,
    totals: Number,
    pageSizes: Number,
    imgs: String,
    heights: {
      type: String,
      default: "470",
    },
    columnS: {
      type: Boolean,
      default: true,
    },
    isInners: String,
  },
  methods: {
    // keydownss(data) {
    //  this.$emit("keydownss",this.Hierarchy[this.Hierarchy.length - 2].id);
    //   if (this.Hierarchy.length != 1) {
    //     this.Hierarchy.splice(this.Hierarchy.length - 1);
    //   }
    // },
    invalidRow(index, val) {
      this.$emit("invalidRow", index, val);
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "总价";
          return;
        }
        const values = data.map((item) => {
          // console.log(column.property);
          if (
            column.property == "AQty" ||
            column.property == "ATotal" ||
            column.property == "BQty" ||
            column.property == "BTotal"
          ) {
            // console.log(Number(item[column.property]))
            if (Number(item[column.property]) != "undefined") {
              return Number(item[column.property]);
            }
          }
        });
        if (!values.every((value) => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr).toFixed(2);
            if (!isNaN(value)) {
              // console.log(
              //   "--->",
              //   Number(prev).toFixed(2),
              //   Number(curr).toFixed(2)
              // );
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          // sums[index] = this.sum(values);
          sums[index];
          // console.log(sums[index]);
        } else {
          // sums[index] = 'N/A';
        }
      });

      return sums;
    },
    clickIcon() {
      this.$emit("clickIcon");
    },
    handleSizeChange(val) {
      // console.log(val);

      // 赋值
      this.$emit("handleSizeChange", val);
    },
    handleCurrentChange(val) {
      //  console.log(val);
      // 赋值
      this.$emit("handleCurrentChange", val);
    },

    deleteRow(index, rows) {
      rows.splice(index, 1);
    },
    // 双击一行
    rowdblclick(obj) {
      this.$emit("dblclick", obj);
    },
    // 单击某一行
    rowclick(obj) {
      this.$emit("rowclick", obj);
    },
    handleClick(obj) {
      let _this = this;
      if (_this.Status) {
        _this.Status = false;
        _this.$emit("handleClick", obj);
      }
      setTimeout(function () {
        _this.Status = true;
      }, 2000);
    },

    deleteClick(index) {
      this.$emit("deleteClick", index);
    },
    deleteClickS(data, index) {
      this.$emit("deleteClickS", data, index);
    },
    Discontinuation(data, index) {
      this.$emit("Discontinuation", data, index);
    },
    Relieveclick(data, index) {
      this.$emit("Relieveclick", data, index);
    },
    constraintclick(data, index) {
      this.$emit("constraintclick", data, index);
    },
  },
  watch: {
    tableData: {
      handler(newValue, oldValue) {
        this.$refs.tableRef.doLayout();
      },
      deep: true,
    },
  },
  created() {},
};
</script>

<style lang="less">
.el-table__fixed-header-wrapper {
  z-index: 25;
}
.btn {
  border: none;
  background-color: transparent;
  color: #409eff;
  font-size: 12px;
  margin-right: 15px;
  padding: 7px 0;
}
.tabone_sty {
  .input_sty {
    background: inherit;
    border: 0;
    outline: 0;
    width: 100%;
    height: 100%;
    display: block;
    box-sizing: border-box;
    padding: 0 10px;
    color: #606266;
  }
}
.el-table__fixed-right {
  width: 130px;
  height: 100% !important;
  right: 0px !important;
}
// .el-button--small{
//   padding: 0 !important;
// }
.el-button {
  font-size: 12px !important;
}
// .is-center {
//   padding: 6px 0 !important;
// }
.el-table__fixed {
  height: 405px;
}
.el-table .cell {
  // overflow: hidden !important;
  white-space: nowrap !important;
  // font-size: 14px;
}
// .tabone_sty td {
//   padding: 0 0 !important;
// }
// .tabone_sty th {
//   padding: 0 !important;
// }
.breadcrumb {
  ul {
    display: flex;
    li {
      list-style: none;
    }
  }
}
.el-table__header-wrapper {
  width: 101% !important;
}
.el-pagination {
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/Table/TableTion/TableTion.vue